import ColorPicker from "components/ColorPicker"
import { SingleSelectField, TextField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FONTS } from "constants/fonts"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  InputGroup,
  InputGroupAddon,
  Row,
} from "reactstrap"
import { change, Field, formValueSelector, isDirty, reset } from "redux-form"
import { FONT_TYPES } from "./constants"

const LinkExploreSetup = ({
  change,
  tabIsActive,
  isDirty,
  resetForm,
  handleSave,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>Text</h4>
        </CardHeader>
        <CardBody>
          <Row className="mb-3">
            <Col xs={12} md={2} lg={1} style={{ minWidth: "fit-content" }}>
              <label>Color:</label>
            </Col>
            <Col xs={12} md={7} xl={5}>
              <Field name="linkColor" component={ColorPicker} />
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} md={2} lg={1} style={{ minWidth: "fit-content" }}>
              <label>Font:</label>
            </Col>
            <Col xs={12} md={7} xl={5}>
              <div style={{ width: "100%" }}>
                <Field
                  className="full-width"
                  name="font"
                  fullWidth={true}
                  component={SingleSelectField}
                  options={FONTS.map(font => ({
                    value: font.value,
                    label: font.text,
                  }))}
                  onFocus={() => change("font", FONT_TYPES.PREDEFINED)}
                />
              </div>
            </Col>
          </Row>
          <Row className="my-3">
            <Col xs={12} md={2} lg={1} style={{ minWidth: "fit-content" }}>
              <label>Size:</label>
            </Col>
            <Col xs={12} md={7} xl={5}>
              <InputGroup style={{ flexWrap: "nowrap" }}>
                <div style={{ width: "100%" }}>
                  <Field name="fontSize" type="number" component={TextField} />
                </div>
                <InputGroupAddon addonType="prepend">pt</InputGroupAddon>
              </InputGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={event => {
          handleSave(event)
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.ONBOARDING_FLOW_WIZARD)

const mapStatetoProps = state => ({
  isDirty: isDirty(FORM_NAMES.ONBOARDING_FLOW_WIZARD)(
    state,
    ...["linkExplore"]
  ),
})

const mapDispatchToProps = dispatch => ({
  change: (name, value) =>
    dispatch(
      change(FORM_NAMES.ONBOARDING_FLOW_WIZARD, `linkExplore.${name}`, value)
    ),
  resetForm: () => dispatch(reset(FORM_NAMES.ONBOARDING_FLOW_WIZARD)),
})

export default connect(mapStatetoProps, mapDispatchToProps)(LinkExploreSetup)
